import React, { useState } from "react";

import { graphql, useLazyLoadQuery } from "react-relay";
import Button from "../../../../Button";

const EMAILS_QUERY = graphql`
  query InvalidSlackEmailsListQuery {
    invalidSlackEmails
  }
`;

export default function InvalidSlackEmailsList() {
  const data = useLazyLoadQuery(EMAILS_QUERY);

  const [clickedEmails, setClickedEmails] = useState([]);

  return (
    <div className="invalid-slack-emails-list-container">
      {data.invalidSlackEmails.length === 0 ||
      data.invalidSlackEmails.length === clickedEmails.length ? (
        <p>No invalid slack users at this time.</p>
      ) : null}

      {data.invalidSlackEmails.map((email) => {
        if (clickedEmails.includes(email)) {
          return null;
        }

        return (
          <Button
            key={email}
            style={{ width: "400px", marginBottom: "25px", userSelect: "none" }}
            onClick={() => {
              console.log(email);
              navigator.clipboard.writeText(email).then(() => {
                setClickedEmails([...clickedEmails, email]);
              });
            }}
          >
            {email}
          </Button>
        );
      })}
    </div>
  );
}
